// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2086":"css/admin-app.6744","4304":"css/app.6744"}[chunkId] + ".css";
};